import { Component, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import { ApplicationGroup } from '../../shared/models/authorizationService.model';
import { AppWizardModuleState } from '../models/app-wizard.model';
import {
  createNewApplicationGroup,
  getApplicationGroups,
} from '../store/actions/app-wizard.actions';

@Component({
  selector: 'app-wizard-create-group',
  templateUrl: './app-wizard-create-group.component.html',
  styleUrls: ['./app-wizard-create-group.component.scss'],
  standalone: false,
})
export class AppWizardCreateGroupComponent {
  @ViewChild(MatStepper) stepper: MatStepper;

  pageTitle$ = this.store.select(SiteSelectors.selectPageTitle);
  applicationGroupNameFormGroup = this.formBuilder.group({
    appGroupNameCtrl: ['', Validators.required],
  });

  constructor(
    private readonly store: Store<AppWizardModuleState>,
    private formBuilder: FormBuilder,
  ) {}

  complete() {
    const newApplicationGroup: ApplicationGroup = {
      id: 0,
      displayName: this.applicationGroupNameFormGroup.get('appGroupNameCtrl').value as string,
      origin: 'Agrifirm',
    };
    this.store.dispatch(createNewApplicationGroup({ newApplicationGroup }));
    this.stepper.next();
    this.store.dispatch(getApplicationGroups());
  }
}
